<template>
    <table >
        <tr>
            <td :colspan="treeData.ivrs ? treeData.ivrs.length * 2 : 1" :class="{parentLevel: treeData.ivrs.length != 0, extend: treeData.ivrs.length != 0 && treeData.extend}">
            <div :class="{node: true}">
                <div class="element">
                    <TreeElement
                        :json="treeData" 
                        @click-extend="toggleExtend(treeData)" 
                        @click-delete="$emit('click-delete', $event)"/>
                </div>                
            </div>
            </td>
        </tr>
        <tr v-if="treeData.extend && treeData.ivrs.length != 0">
            <td v-for="(ivrs, index) in treeData.ivrs" :key="index" colspan="2" class="childLevel">
                <TreeChart 
                    :json="ivrs" 
                    @click-extend="toggleExtend(treeData)" 
                    @click-node="$emit('click-node', $event)"
                    @click-delete="removeElement"/>
            </td>        
        </tr>
    </table>
</template>

<script>
import TreeElement from './TreeElement';
export default {
    name: "TreeChart",
    components: {
        TreeElement
    },
    props: ["json"],
    data() {
        return {
            treeData: {}
        }
    },
    watch: {
        json: {
            handler: function(Props){
                let extendKey = function(jsonData){
                    jsonData.extend = (jsonData.extend===void 0 ? true: !!jsonData.extend);
                    if (jsonData.ivrs.length != 0) {
                        jsonData.ivrs.forEach(c => {
                            extendKey(c)
                        })
                    }
                    return jsonData;
                }
                if (Props) {
                    this.treeData = extendKey(Props);
                }
            },
            immediate: true
        }
    },
    methods: {
        toggleExtend: function(treeData) {
            treeData.extend = !treeData.extend;
            this.$forceUpdate();
        },
        removeElement(element) {
            var index = this.treeData.ivrs.indexOf(element)
            if (this.treeData.ivrs.indexOf(element) != -1) {
                this.treeData.ivrs.splice(index, 1)
            }
            this.$forceUpdate();
        }
    }
}
</script>

<style scoped>
table{border-collapse: separate!important;border-spacing: 0!important;}
td{position: relative; vertical-align: top;padding:0 0 30px 0;text-align: center!important; }
.extend::after{content: "";position: absolute;left:50%;bottom:15px;height:15px;border-left:2px solid #ccc;transform: translate3d(-1px,0,0)}
.childLevel::before{content: "";position: absolute;left:50%;bottom:100%;height:15px;border-left:2px solid #ccc;transform: translate3d(-1px,0,0)}
.childLevel::after{content: "";position: absolute;left:0;right:0;top:-15px;border-top:2px solid #ccc;}
.childLevel:first-child:before, .childLevel:last-child:before{display: none;}
.childLevel:first-child:after{left:50%;height:15px; border:2px solid;border-color:#ccc transparent transparent #ccc;border-radius: 6px 0 0 0;transform: translate3d(1px,0,0)}
.childLevel:last-child:after{right:50%;height:15px; border:2px solid;border-color:#ccc #ccc transparent transparent;border-radius: 0 6px 0 0;transform: translate3d(-1px,0,0)}
.childLevel:first-child.childLevel:last-child::after{left:auto;border-radius: 0;border-color:transparent #ccc transparent transparent;transform: translate3d(1px,0,0)}
.node{position: relative; display: inline-block; width: 14em;text-align: center!important;}
.node .element{position: relative;display: inline-block;z-index: 4;}
</style>